export default function CleverButton() {
  return (
    <img
      loading="lazy"
      id="cleverButton"
      src="https://files.readme.io/31c4e09-LogInWithClever--Secondary2x.png"
    />
  );
}
